<!-- #region État de la navigation : échec (message, Retour / Réessayer), chargement plein écran ou barre de progression -->
@if (etat.echec(); as e) {
  <div [class]="appClasses + ' nav-etat'" role="alert">
    <app-etat-vide class="card carte-seule" icon="alert" [titre]="e.titre" [texte]="e.texte">
      <div class="nav-etat-a">
        <button type="button" class="btn btn-ghost" (click)="etat.retour()">{{ etat.libelleRetour() }}</button>
        <button type="button" class="btn btn-primary" (click)="etat.reessayer()">
          <svg appIcone name="refresh" [size]="15"></svg>Réessayer
        </button>
      </div>
    </app-etat-vide>
  </div>
} @else if (etat.chargement()) {
  <div [class]="appClasses + ' nav-etat'" aria-busy="true"><app-indicateur-chargement /></div>
} @else if (etat.barre()) {
  <div class="nav-barre" role="progressbar" aria-label="Chargement de l’écran"></div>
}
<!-- #endregion -->
